module.exports = require("/mnt/e/projects/personal-site/.gatsby/gatsby-browser.tsx");